import React from 'react';
import './index.scss'

const Resume = () => {
    return (
        <div className='container resume-page'>
            <h1 className='title'>Resume</h1>
            <div className='resume-img'></div>
        </div>
    )
}

export default Resume;